import { render, staticRenderFns } from "./view_FreeIssue-AstralitoAdultos.vue?vue&type=template&id=b2a3c9de&scoped=true&"
import script from "./view_FreeIssue-AstralitoAdultos.vue?vue&type=script&lang=js&"
export * from "./view_FreeIssue-AstralitoAdultos.vue?vue&type=script&lang=js&"
import style0 from "./view_FreeIssue-AstralitoAdultos.vue?vue&type=style&index=0&id=b2a3c9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a3c9de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
